import React, { useEffect, useRef, useState } from 'react';
import { resenas } from '../data/viajes';
import { destinoEnLinea, encuadreDe, nombreCorto, resumenResena } from '../services/resenas';
import { micro, mini } from '../utils';
import './Testimonios.css';

const pad = (n) => (n < 10 ? '0' : '') + n;

export default function Testimonios({ onVerEnMapa }) {
  const [i, setI] = useState(0);
  const [abierta, setAbierta] = useState(false);
  const hover = useRef(false);
  const cuerpo = useRef(null);
  const primera = useRef(true);
  const n = resenas.length;

  useEffect(() => {
    const t = setInterval(() => { if (!hover.current && !abierta) setI((k) => (k + 1) % n); }, 9000);
    return () => clearInterval(t);
  }, [abierta, n]);

  useEffect(() => {
    if (primera.current) { primera.current = false; return; }
    if (cuerpo.current) cuerpo.current.animate([{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }], { duration: 650, easing: 'cubic-bezier(.2,.8,.2,1)' });
  }, [i]);

  const ir = (k) => { setI((k + n) % n); setAbierta(false); };
  const r = resenas[i];
  const { completo, corto, largo } = resumenResena(r);
  const texto = abierta ? completo : corto;

  return (
    <section id="viajeros" className="viajeros sec on-dark">
      <div className="wrap">
        <div className="viajeros__head" data-reveal>
          <div>
            <p className="eyebrow">Mis viajeros</p>
            <h2 className="h2">Familias que ya <em>viajaron conmigo</em></h2>
          </div>
          <div className="viajeros__nav">
            <span>{pad(i + 1)} / {pad(n)}</span>
            <button onClick={() => ir(i - 1)} aria-label="Anterior"><i className="fa-solid fa-arrow-left" /></button>
            <button onClick={() => ir(i + 1)} aria-label="Siguiente" className="is-main"><i className="fa-solid fa-arrow-right" /></button>
          </div>
        </div>

        <div className="viajeros__body" ref={cuerpo} onMouseEnter={() => { hover.current = true; }} onMouseLeave={() => { hover.current = false; }}>
          <div className="viajeros__foto">
            <figure className="polaroid"><img src={mini(r.imagen)} alt={r.nombre} loading="lazy" decoding="async" style={{ objectPosition: encuadreDe(r) }} /><figcaption>{r.nombre}</figcaption></figure>
          </div>
          <div className="viajeros__texto">
            <span className="viajeros__stars">{Array.from({ length: r.estrellas }, (_, k) => <i key={k} className="fa-solid fa-star" />)}</span>
            <p className="viajeros__cita">“{texto}”</p>
            {largo && <button className="viajeros__mas" onClick={() => setAbierta(!abierta)}>{abierta ? 'Ver menos' : 'Leer completa'}</button>}
            <div className="viajeros__pie">
              <div>
                <p className="viajeros__n">{r.nombre}</p>
                <p className="viajeros__d"><i className="fa-solid fa-location-dot" />{destinoEnLinea(r)}</p>
              </div>
              {onVerEnMapa && <button className="btn-ghost" onClick={() => onVerEnMapa(r.lugar)}><i className="fa-solid fa-earth-americas" />Ver en mi mapa</button>}
            </div>
          </div>
        </div>

        <div className="viajeros__thumbs">
          {resenas.map((x, k) => (
            <button key={x.id} onClick={() => ir(k)} className={k === i ? 'is-on' : ''}>
              <img src={micro(x.imagen)} alt="" loading="lazy" decoding="async" style={{ objectPosition: encuadreDe(x) }} />
              <span>{nombreCorto(x)}</span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
